export const EMPTY_TEXT = `Список пуст. Подберите товары в каталоге.`;
export const EMPTY_LINK_TEXT = `Посмотреть каталог`;
